<template>
  <div class="lead-mask row gutter-xs">
    <lead-mask-element
      v-for="element in elements"
      :key="element.name"
      :class="getItemGrid(element)"
      :type="element.element_type"
      :element="element"
      :errors="errors"
      @populate-fields="populateFields"
      :name="element.name"
      :language="language"
      v-on:change="change"
      :item="item">
    </lead-mask-element>
  </div>
</template>
<script>
import LeadMaskElement from '@/components/pages/project/leads/LeadMaskElement'
import Mask from '@/classes/Mask'

export default {
  components: { LeadMaskElement },
  props: ['item', 'elements', 'errors', 'language'],
  methods: {
    autofill(autofillItem){
      this.$emit('autofill-lead', autofillItem)
    },
    // see: LeadUpdate#change for reasoning
    change(object, label ,name) {
      this.$emit('change', object, label ,name)
    },
    populateFields(companyFields){
      this.$emit('populate-fields', companyFields)
    },
    getItemGrid(item) {

      if (item.class) {
        return item.class
      } else {
        return "col-12"
      }

    },
  },
}
</script>
<style lang="scss">
.lead-mask {

  [class*="grid-2"] > * {
    width: 100%;
  }
  [class*="grid-2"].has-gutter > * {
    width: 100%;
  }
  input,
  select {
    margin-bottom: 0;
  }
  .grid {
    flex-direction: column;
  }

  .vdp-datepicker__clear-button {
    top: 6px;
  }

  .vdp-datepicker::before {
    margin-top: -4px;
  }

}
.field .required{
  font-style: normal;
}
</style>



// WEBPACK FOOTER //
// LeadMask.vue?576b6c91